import { createBrowserHistory } from "history";
const history = createBrowserHistory("/App");
export default history;